// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contratos_MinutaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /contratos/minuta/:id e POST /contratos/minuta_salvar, minuta_aprovar, minuta_descartar — a minuta como ficou. */
import type { Contratos_MinutaRow } from './Contratos_MinutaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Contratos_MinutaResponseDados {
minuta: Contratos_MinutaRow
modelo_versao_vigente: number
}

export type Contratos_MinutaResponse = ApiResponse<Contratos_MinutaResponseDados>;

registerResponseContract('Contratos_MinutaResponse', {
  minuta: {
    type: 'object',
    required: true,
    fields: {
      id:            { type: 'number',  required: true },
      franquia_id:   { type: 'number',  required: true },
      modelo_versao: { type: 'number',  required: true },
      situacao:      { type: 'string',  required: true },
      pedido:        { type: 'string',  required: false },
      clausulas: {
        type: 'array',
        required: false,
        items: {
          chave:  { type: 'string',  required: false },
          titulo: { type: 'string',  required: false },
          texto:  { type: 'string',  required: false },
          fixa:   { type: 'boolean', required: false },
        },
      },
      padrao: {
        type: 'array',
        required: false,
        items: {
          chave:  { type: 'string',  required: false },
          titulo: { type: 'string',  required: false },
          texto:  { type: 'string',  required: false },
          fixa:   { type: 'boolean', required: false },
        },
      },
      criado_por:    { type: 'string',  required: false },
      atualizado_em: { type: 'string',  required: true },
      aprovado_por:  { type: 'string',  required: false },
      aprovado_em:   { type: 'string',  required: false },
    },
  },
  modelo_versao_vigente: { type: 'number',  required: true },
})
